import React from 'react';
import propTypes from 'prop-types';
import { Provider } from 'react-redux';
import * as I18n from '../lib/hoc';
import store from '../store';
import { NotificationsPopover } from '../Components';
import { NOTIFICATIONS_DRAWER_LOG_MODULE } from '../../RealtimeNotifications/shared/constants';
import { SafeComponent } from '../../shared/SafeComponent';
import { TYPES } from './types';
import './style.scss';

const NotificationsDrawer = ({
    username,
    locale,
    drawerType,
    notificationSoundEnabled,
    popoverClassName,
    popoverBoxClassName,
    unreadDotClassName,
    trigger,
    onTriggerClick,
    allowOverflow,
}) => (
    <Provider store={store}>
        <I18n.Provider locale={locale}>
            <NotificationsPopover
                allowOverflow={allowOverflow}
                username={username}
                drawerType={drawerType}
                notificationSoundEnabled={notificationSoundEnabled}
                popoverClassName={popoverClassName}
                popoverBoxClassName={popoverBoxClassName}
                unreadDotClassName={unreadDotClassName}
                trigger={trigger}
                onTriggerClick={onTriggerClick}
            />
        </I18n.Provider>
    </Provider>
);

NotificationsDrawer.propTypes = {
    allowOverflow: propTypes.bool,
    username: propTypes.string,
    locale: propTypes.string,
    notificationSoundEnabled: propTypes.bool,
    popoverClassName: propTypes.string,
    popoverBoxClassName: propTypes.string,
    unreadDotClassName: propTypes.string,
    drawerType: propTypes.oneOf([
        TYPES.MESSAGES,
        TYPES.BOTH,
        TYPES.NOTIFICATIONS,
        TYPES.MESSAGES_MODERN,
        TYPES.NOTIFICATIONS_MODERN,
    ]),
    trigger: propTypes.node,

    /**
     * Optional - a callback that will be called when the user clicks on the trigger
     * @param {Object} params
     * @param {Boolean} params.isOpen - whether the panel is open
     * @param {String} params.appName - the name of the trigger - 'conversations' / 'notifications'
     */
    onTriggerClick: propTypes.func,
};

export default SafeComponent(NOTIFICATIONS_DRAWER_LOG_MODULE, 'NotificationsDrawer')(NotificationsDrawer);
